<template>
  <div class="status-box" v-if="$slots.default">
    <div class="status" :style="{ background: statusList[status].color }"></div>
    <div class="label">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * status--状态`
 * 插槽展示文字
 *
 *  */
export default {
  props: {
    status: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      statusList: [
        {
          // 已完成
          status: 0,
          color: "#60C873",
        },
        {
          // 进行中
          status: 1,
          color: "#5085FF",
        },
        {
          // 待执行
          status: 2,
          color: "#F89F39",
        },
        {
          // 已失败
          status: 3,
          color: "#FE7575",
        },
        {
          // 已结束
          status: 4,
          color: "#8B8B8B",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.status-box {
  display: flex;
  // justify-content: center;
  align-items: center;
  .status {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  .label {
    margin-left: 4px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}
</style>
